import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Polyline,
  useJsApiLoader,
} from "@react-google-maps/api";
import {
  Box,
  Typography,
  TextField,
  Button,
  Stack,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Snackbar,
  Alert,
  Backdrop,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  Chip,
  IconButton,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import { Map as MapIcon, MyLocation, Search, AddLocationAlt, Place, Delete, Save, AltRoute } from "@mui/icons-material";
import axios from "axios";
import { create_travel_route, map_search, travel_admin } from "../api/API";
import { AdminPage, SectionTitle, GREEN, LIGHT, BORDER, primaryButtonSx, subCardSx } from "../admin/AdminPageLayout";

const mapContainerStyle = { width: "100%", height: "100%" };
const defaultCenter = { lat: 13.736717, lng: 100.523186 }; // กทม.

const MainAddRouteMap = () => {
  const [points, setPoints] = useState([]);
  const [routePath, setRoutePath] = useState([]); // เก็บเส้นทางที่ได้จาก Directions API
  const [input, setInput] = useState("");
  const mapRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [travelses, setTravelses] = useState([]); // 👉 ลิสต์ข้อมูลจาก API
  const [selectedTravelses, setSelectedTravelses] = useState(""); // 👉 tid ที่ถูกเลือก
  const token = localStorage.getItem("token");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertOpentravel, setAlertOpentravel] = useState(false);
  const [alertMessagetravel, setAlertMessagetravel] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // "success" | "error" | "warning" | "info"

  const [placeOptions, setPlaceOptions] = useState([]);
  const [selectedPlaceName, setSelectedPlaceName] = useState("");
  const [selectedPlace, setSelectedPlace] = useState(null); // ข้อมูลเต็มของสถานที่ที่เลือก
  const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  });

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const loadTravelses = async () => {
    try {
      const response = await axios.get(travel_admin, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setTravelses(response.data || []); // ตรวจสอบรูปแบบ data ด้วย (array?)
      console.log("✅ ดึงข้อมูลอำเภอสำเร็จ:", response.data);
    } catch (error) {
      console.error("❌ ดึงข้อมูลอำเภอล้มเหลว:", error);
    }
  };
  // ฟังก์ชันเรียก Directions API และตั้งค่าเส้นทาง
  const fetchRoute = async (points) => {
    if (points.length < 2) {
      setRoutePath([]);
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();

    const origin = points[0];
    const destination = points[points.length - 1];
    const waypoints = points.slice(1, points.length - 1).map((p) => ({
      location: { lat: p.lat, lng: p.lng },
      stopover: true,
    }));

    directionsService?.route(
      {
        origin,
        destination,
        waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING, // หรือ WALKING, BICYCLING ตามต้องการ
        optimizeWaypoints: true, // เพื่อให้ Google หาทางที่ใกล้ที่สุด
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          const path = [];

          // ดึง path ทุกจุดจาก legs ของ route
          result.routes[0].legs.forEach((leg) => {
            leg.steps.forEach((step) => {
              step.path.forEach((latlng) => {
                path.push({ lat: latlng.lat(), lng: latlng.lng() });
              });
            });
          });

          setRoutePath(path);
        } else {
          console.error("Directions request failed due to " + status);
          setRoutePath([]);
        }
      }
    );
  };

  const handleAddPoint = async () => {
    const parts = input.split(",");
    if (parts.length !== 2) {
      alert("กรุณากรอกพิกัดในรูปแบบ lat,lng เช่น 13.7367,100.5231");
      return;
    }

    const lat = parseFloat(parts[0].trim());
    const lng = parseFloat(parts[1].trim());

    if (isNaN(lat) || isNaN(lng)) {
      alert("พิกัดไม่ถูกต้อง");
      return;
    }
    // console.log("lat", lat);
    // console.log("lng", lng);

    try {
      const res = await fetch(
        `${map_search}?lat=${lat}&lng=${lng}`,
        {
          method: "GET", // กรณีนี้ใช้ GET
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      // console.log("📍 ข้อมูลจาก API หลังบ้าน:", data);

      if (data.results?.length > 0) {
        setPlaceOptions(data.results);
        // setSelectedPlaceName(data.results[0].name);
      } else {
        setPlaceOptions([]);
        setSelectedPlaceName(`(${lat.toFixed(6)}, ${lng.toFixed(6)})`);
      }
    } catch (error) {
      console.error("❗ Error fetching place info:", error);
      setPlaceOptions([]);
      setSelectedPlaceName(`(${lat}, ${lng})`);
    }
  };

  const handleConfirmAdd = () => {
    if (!selectedPlace) return;

    const newPoint = {
      lat: selectedPlace.lat,
      lng: selectedPlace.lng,
      name: selectedPlace.name,
    };

    const newPoints = [...points, newPoint];
    setPoints(newPoints);
    setInput("");
    setPlaceOptions([]);
    setSelectedPlaceName("");
    // setSelectedPlace(null);
    fetchRoute(newPoints); // ค่อยเรียกหาเส้นทาง
  };

  const handletravelsesChange = (event) => {
    const tid = event.target.value;
    setSelectedTravelses(tid); // ✅ เก็บค่า tid ที่เลือก
    console.log("🆔 tid ที่เลือก:", tid);
  };

  useEffect(() => {
    // 1. โหลด Districts ครั้งเดียวเมื่อ map พร้อม
    if (isLoaded && token && travelses.length === 0) {
      loadTravelses();
    }

    // 2. Pan ไปยังจุดล่าสุดเมื่อเพิ่มจุด
    if (points.length && mapRef.current) {
      const last = points[points.length - 1];
      mapRef.current.panTo(last);
      if (points.length === 1) {
        mapRef.current.setZoom(14);
      }
    }
  }, [points, isLoaded, token]);

  const handleSaveData = async () => {
    if (!selectedTravelses || selectedTravelses.length === 0) {
      setAlertMessagetravel("โปรดเลือกอำเภอ");
      setAlertOpentravel(true);
      return;
    }

    if (points.length < 2) {
      setAlertMessage("ต้องเพิ่มจุดอย่างน้อย 2 จุดก่อนบันทึกข้อมูล");
      setAlertOpen(true);
      return;
    }

    setLoading(true); // 🔄 เริ่มโหลด

    try {
      const enrichedPoints = points.map((point) => ({
        ...point,
        tid: selectedTravelses,
      }));

      const response = await axios.post(
        create_travel_route,
        enrichedPoints,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setSnackbarMessage("✅ ข้อมูลถูกบันทึกเรียบร้อยแล้ว!");
        setSnackbarSeverity("success");

        // 🧹 เคลียร์ค่าหลังบันทึก
        setPoints([]);
        setSelectedTravelses(null); // หรือ [] ขึ้นอยู่กับรูปแบบ
      } else {
        setSnackbarMessage("❌ ไม่สามารถบันทึกข้อมูลได้");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("❗ Error ส่งข้อมูล:", error);
      setSnackbarMessage("⚠️ เกิดข้อผิดพลาดขณะส่งข้อมูล");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
      setLoading(false); // 🔚 หยุดโหลด
    }
  };

  if (loadError) return <div>Map cannot be loaded right now, sorry.</div>;
  if (!isLoaded) return <div>Loading Maps...</div>;

  return (
    <>
      <AdminPage
        icon={<MapIcon fontSize="large" />}
        title="เพิ่มแผนที่ Route"
        subtitle="เลือกเส้นทาง ค้นหาพิกัด แล้วเพิ่มจุดเพื่อสร้างเส้นทางบน Google Map"
        maxWidth={1100}
        actions={
          points.length > 0 && (
            <Button
              variant="contained"
              size="large"
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Save />}
              sx={primaryButtonSx}
              onClick={handleSaveData}
              disabled={loading}
            >
              {loading ? "⏳ กำลังบันทึก..." : "💾 บันทึกข้อมูล"}
            </Button>
          )
        }
      >
        <SectionTitle step={1} title="เลือกเส้นทาง" />
        <FormControl fullWidth size="medium">
          <InputLabel id="travelses-select-label">เส้นทาง</InputLabel>
          <Select
            name="travelses-select"
            labelId="travelses-select-label"
            id="travelses-select"
            value={selectedTravelses} // ✅ ใช้ค่าที่เลือก
            label="เส้นทาง"
            onChange={handletravelsesChange}
            startAdornment={<InputAdornment position="start"><AltRoute sx={{ color: GREEN }} /></InputAdornment>}
            sx={{
              bgcolor: "white",
              borderRadius: 1,
            }}
          >
            <MenuItem value="">
              <em>-- เลือกอำเภอ --</em>
            </MenuItem>
            {travelses?.map((d) => (
              <MenuItem key={d.tid} value={d.tid}>
                {d.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Divider sx={{ my: 3 }} />
        <SectionTitle step={2} title="ค้นหาและเพิ่มพิกัด" />
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md>
            <TextField
              fullWidth
              label="พิกัด (lat,lng)"
              placeholder="เช่น 13.7367,100.5231"
              variant="outlined"
              size="medium"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              InputProps={{
                startAdornment: <InputAdornment position="start"><MyLocation sx={{ color: GREEN }} /></InputAdornment>,
              }}
              sx={{
                bgcolor: "white",
                borderRadius: 1,
              }}
            />
          </Grid>
          <Grid item xs={12} md="auto">
            <Button
              variant="contained"
              size="large"
              startIcon={<Search />}
              onClick={handleAddPoint}
              sx={{ ...primaryButtonSx, height: 56, width: { xs: "100%", md: "auto" } }}
            >
              ค้นหาสถานที่
            </Button>
          </Grid>
          {/* {placeOptions.length > 0 && ( */}
          <Grid item xs={12} md>
            <FormControl fullWidth>
              <InputLabel id="place-select-label">เลือกสถานที่</InputLabel>
              <Select
                sx={{
                  bgcolor: "white",
                  borderRadius: 1,
                }}
                labelId="place-select-label"
                value={selectedPlaceName}
                label="เลือกสถานที่"
                startAdornment={<InputAdornment position="start"><Place sx={{ color: GREEN }} /></InputAdornment>}
                onChange={(e) => {
                  const name = e.target.value;
                  setSelectedPlaceName(name);
                  const matched = placeOptions.find((p) => p.name === name);
                  if (matched) {
                    setSelectedPlace(matched);
                    // 👇 คุณสามารถเรียกแสดง marker preview ที่นี่
                  }
                }}
              >
                {placeOptions.map((place, index) => (
                  <MenuItem key={index} value={place.name}>
                    {place.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md="auto">
            <Button
              variant="outlined"
              size="large"
              startIcon={<AddLocationAlt />}
              disabled={selectedPlaceName === ""}
              sx={{
                height: 56,
                borderRadius: 3,
                width: { xs: "100%", md: "auto" },
                borderColor: GREEN,
                color: GREEN,
                "&:hover": { borderColor: GREEN, bgcolor: LIGHT },
              }}
              onClick={handleConfirmAdd}
            >
              เพิ่มพิกัด
            </Button>
          </Grid>
          {/* )} */}
        </Grid>

        <Divider sx={{ my: 3 }} />
        <SectionTitle step={3} title="แผนที่เส้นทาง" />
        <Box
          sx={{
            borderRadius: 3,
            border: `1px solid ${BORDER}`,
            overflow: "hidden",
            height: { xs: 320, sm: 420, md: 500 }, // ต้องกำหนดความสูงให้ map แสดงผล
          }}
        >
          <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={points.length ? points[0] : defaultCenter}
            zoom={6}
            onLoad={(map) => (mapRef.current = map)}
          >
            {points.map((p, idx) => (
              <Marker
                key={idx}
                position={{ lat: p.lat, lng: p.lng }}
                label={`${idx + 1}`}
                title={p.name}
              />
            ))}

            {routePath.length > 0 && (
              <Polyline
                path={routePath}
                options={{
                  strokeColor: "#2e7d32",
                  strokeOpacity: 0.9,
                  strokeWeight: 5,
                }}
              />
            )}
          </GoogleMap>
        </Box>

        <Divider sx={{ my: 3 }} />
        <SectionTitle
          step={4}
          title="รายการพิกัดที่เพิ่ม"
          extra={points.length > 0 && (
            <Chip size="small" label={`${points.length} จุด`} sx={{ bgcolor: LIGHT, color: GREEN, fontWeight: 600 }} />
          )}
        />
        {points.length === 0 && (
          <Box sx={{ textAlign: "center", py: 3, color: "text.secondary", border: `1px dashed ${BORDER}`, borderRadius: 3, bgcolor: "#fafdf7" }}>
            <Place sx={{ fontSize: 40, color: "#aed581" }} />
            <Typography variant="body2">ยังไม่มีพิกัด ค้นหาสถานที่แล้วกด “เพิ่มพิกัด”</Typography>
          </Box>
        )}
        {points.length > 0 && (
          <Stack spacing={1.5}>
            {points.map((point, idx) => (
              <Paper
                key={idx}
                variant="outlined"
                sx={{ ...subCardSx, p: 1.5, display: "flex", alignItems: "center", gap: 1.5 }}
              >
                <Chip size="small" label={idx + 1} sx={{ bgcolor: GREEN, color: "white", fontWeight: 700 }} />
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Typography fontWeight={600} noWrap>
                    {`พิกัดที่ : ${idx + 1}`}. {point.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    ({point.lat.toFixed(6)}, {point.lng.toFixed(6)})
                  </Typography>
                </Box>
                <Tooltip title="ลบ">
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => {
                      const updatedPoints = points.filter((_, i) => i !== idx);
                      setPoints(updatedPoints);
                      fetchRoute(updatedPoints); // อัปเดตเส้นทาง
                    }}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Paper>
            ))}
          </Stack>
        )}
      </AdminPage>

      {/* 🔄 Backdrop ขณะโหลด */}
      <Backdrop
        open={loading}
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity="warning"
          sx={{
            width: "100%",
            backgroundColor: "#d32f2f", // แดงเข้ม (error main)
            color: "#fff", // ตัวอักษรขาว
            "& .MuiAlert-icon": {
              color: "#fff", // ไอคอนขาวด้วย
            },
          }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={alertOpentravel}
        autoHideDuration={3000}
        onClose={() => setAlertOpentravel(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setAlertOpentravel(false)}
          severity="warning"
          sx={{
            width: "100%",
            backgroundColor: "#d32f2f", // แดงเข้ม (error main)
            color: "#fff", // ตัวอักษรขาว
            "& .MuiAlert-icon": {
              color: "#fff", // ไอคอนขาวด้วย
            },
          }}
        >
          {alertMessagetravel}
        </Alert>
      </Snackbar>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default MainAddRouteMap;
